import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=04ebbba2&scoped=true"
import script from "./UserManagement.vue?vue&type=script&lang=js"
export * from "./UserManagement.vue?vue&type=script&lang=js"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=04ebbba2&prod&lang=less"
import style1 from "./UserManagement.vue?vue&type=style&index=1&id=04ebbba2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ebbba2",
  null
  
)

export default component.exports